
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("unuyV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f43fc926f5a84a0a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $f43fc926f5a84a0a$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': "Actualiser l'app",
    'confluence.error.panel.reload.page': 'Recharger la page',
    'confluence.icon.label': "Ic\xf4ne",
    'confluence.modal.dialog.close.modal.button': 'Annuler',
    'confluence.select.required.field.message': 'Ce champ est obligatoire.',
    'confluence.text.area.required.field.message': 'Ce champ est obligatoire.',
    'confluence.textfield.validator.email': 'Saisissez une adresse e-mail valide.',
    'confluence.textfield.validator.number': 'Indiquez un nombre valide',
    'confluence.textfield.validator.required.field.message': 'Ce champ est obligatoire.',
    'confluence.textfield.validator.telephone': "Saisissez un num\xe9ro de t\xe9l\xe9phone valide.",
    'confluence.threeLOPrompt.modal.access.required.title': "Acc\xe8s requis",
    'confluence.threeLOPrompt.modal.error.title': 'Erreur',
    'confluence.threeLOPrompt.modal.no.authURL.error-message': "URL de consentement introuvable. Veuillez actualiser la page et r\xe9essayer.",
    'confluence.threeLOPrompt.no.authURL.error-message': "URL de consentement introuvable. Veuillez actualiser la page et r\xe9essayer.",
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': "Autoriser l'acc\xe8s",
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': "Configurer l'acc\xe8s",
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': "\xc9chec de l'authentification.",
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "Pour afficher {appString}, vous devez autoriser l'app \xe0 acc\xe9der aux produits\xa0Atlassian en votre nom.",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': "{appString} n\xe9cessite un acc\xe8s suppl\xe9mentaire \xe0 votre compte.",
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': "Avertissement d'authentification externe",
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'cette app',
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Cette app',
    'confluence.user.group.unknown.user.message': 'Utilisateur inconnu',
    'confluence.user.picker.empty.field.error.message': 'Ce champ est obligatoire.',
    'confluence.user.unknown.user.message': 'Utilisateur inconnu',
    'forge-ui.form.submit-button.text': 'Envoyer'
};

});


//# sourceMappingURL=fr.800598b5.js.map
